
import { useNavigate } from "react-router-dom";
import {
  createProductApi,
  getProductTypeApi,
  getProductUnitApi,
} from "../../../../callApi/productApi";
import CustomButton from "../../../../components/CustomButton";
import CustomInput from "../../../../components/CustomInput";
import CustomInputProduct from "../../../../components/CustomInputProduct";
import CustomHeader from "../../../../components/admin/CustomHeader";
import CustomLeftBar from "../../../../components/admin/CustomLeftBar";
import { Icon } from "@iconify/react";
import Notiflix from "notiflix";
import React, { useEffect, useState } from "react";
import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";

export default function AdminProductsAdd() {
  const [name, setname] = useState("");
  const [old, setold] = useState("");
  const [no, setno] = useState("");
  const [amount, setamount] = useState("");
  const [product_types_id, setproduct_types_id] = useState("");
  const [price, setprice] = useState("");
  const [technic, settechnic] = useState("");
  const [note, setnote] = useState("");
  const [pattern, setpattern] = useState("");
  const [material, setmaterial] = useState("");
  const [attribute_old, setattribute_old] = useState("");
  const [width, setwidth] = useState("");
  const [length, setlength] = useState("");
  const [depth, setdepth] = useState("");
  const [product_units_id, setproduct_units_id] = useState("");
  const [product_img, setproduct_img] = useState(null);
  const [type, settype] = useState([]);
  const [unit, setunit] = useState([]);
  const router = useNavigate();
  useEffect(() => {
    CallType();
    CallUnit();
  }, []);

  const CallType = async () => {
    let res = await getProductTypeApi();
    if (res.status == 200) {
      settype(res.data.data);
    }
  };
  const CallUnit = async () => {
    let res = await getProductUnitApi();
    if (res.status == 200) {
      setunit(res.data.data);
      if (res.data.data.length > 0) {
        setproduct_units_id(res.data.data[0]);
      }
    }
  };
  const saveData = async () => {
    if (product_types_id.id == undefined) {
      Notiflix.Notify.warning("กรุณาเลือกประเภท");
    } else if (product_units_id.id == undefined) {
      Notiflix.Notify.warning("กรุณาเลือกหน่วย");
    } else {
          Notiflix.Loading.circle();
      let res = await createProductApi({
        amount,
        attribute_old,
        depth,
        length,
        material,
        name,
        no,
        note,
        old,
        pattern,
        price,
        product_img,
        product_types_id: product_types_id.id,
        product_units_id: product_units_id.id,
        technic,
        width,
      });
          Notiflix.Loading.remove();
      if (res.status == 200) {
        Notiflix.Notify.success("บันทึกสำเร็จ");
        router("/admin/products/" + res.data.data.id);
      } else {
        Notiflix.Notify.failure("ผิดพลาด");
      }
    }
  };
  return (
    <div className="flex flex-col h-screen">
      <CustomHeader />
      <div className="flex flex-row flex-[1] overflow-hidden">
        <CustomLeftBar page="Products" subPage="Add New Products" />
        <div className="p-8 flex flex-col  flex-[1] overflow-y-auto">
          <div className=" font-semibold text-[24px]">ผลิตภัณฑ์</div>
          <div className="border flex flex-col gap-5 rounded-lg p-5">
            <div className="grid grid-cols-2 gap-2">
              <CustomInputProduct
                value={name}
                onChange={(v) => setname(v)}
                title="ชื่อผลิตภัณฑ์"
                placeHolder="กรุณากรอกชื่อผลิตภัณฑ์"
                fontSize={14}
              />
              <CustomInputProduct
                value={no}
                onChange={(v) => setno(v)}
                title="รหัสผลิตภัณฑ์"
                placeHolder="กรุณากรอกรหัสผลิตภัณฑ์"
                fontSize={14}
              />
              <CustomInputProduct
                value={product_types_id}
                onChange={(v) => setproduct_types_id(v)}
                title="ประเภท"
                placeHolder="กรุณาเลือกประเภท"
                fontSize={14}
                type={"select"}
                data={type}
              />

              <CustomInputProduct
                value={product_units_id}
                onChange={(v) => setproduct_units_id(v)}
                title="หน่วยวัด"
                placeHolder="กรุณาเลือกประเภท"
                fontSize={14}
                type={"select"}
                data={unit}
              />
              <div className="flex flex-row items-center justify-center border rounded-md col-span-2 h-56">
                {product_img ? (
                  <div className="flex flex-col items-center gap-2">
                    <Zoom>
                      <img
                        src={URL.createObjectURL(product_img)}
                        className="h-32 object-contain rounded-lg drop-shadow-lg"
                      />
                    </Zoom>
                    <div
                      onClick={() => {
                        document.getElementById("inputFile").click();
                      }}
                      className=" cursor-pointer  bg-white rounded-md drop-shadow-lg px-2 py-1 flex flex-row items-center text-black hover:bg-[#9E0400] hover:text-white"
                    >
                      <Icon icon={"uil:image-plus"} />
                      <p>เลือกภาพ</p>
                    </div>
                    <div
                      onClick={() => {
                        setproduct_img(null);
                      }}
                      className=" cursor-pointer  bg-white rounded-md drop-shadow-lg px-2 py-1 flex flex-row items-center text-black hover:bg-[#9E0400] hover:text-white"
                    >
                      <Icon icon={"uil:image-times"} />
                      <span>ลบ</span>
                    </div>
                  </div>
                ) : (
                  <div
                    onClick={() => {
                      document.getElementById("inputFile").click();
                    }}
                    className=" cursor-pointer flex flex-row gap-2 items-center hover:opacity-80 active:opacity-50"
                  >
                    <Icon icon={"uil:image-v"} className="text-3xl" />
                    <p>เพิ่มภาพหลัก</p>
                  </div>
                )}
                <input
                  onChange={(e) => {
                    if (e.target.files.length > 0) {
                      console.log("e.target.files", e.target.files[0]);
                      setproduct_img(e.target.files[0]);
                    }
                  }}
                  type="file"
                  className="hidden"
                  name={"inputFile"}
                  id={"inputFile"}
                  accept=".png, .jpg, .jpeg"
                  multiple={true}
                  max={1}
                  maxLength={1}
                />
              </div>
            </div>
            <div>ข้อมูลเพิ่มเติม</div>
            <div className="grid grid-cols-2 gap-2">
              <CustomInputProduct
                value={amount}
                onChange={(v) => setamount(v)}
                title="จำนวน"
                placeHolder="กรุณาใส่รายละเอียด"
                fontSize={14}
              />
              <CustomInputProduct
                value={price}
                onChange={(v) => setprice(v)}
                title="ราคา / หน่วย"
                placeHolder="กรุณาใส่รายละเอียด"
                fontSize={14}
              />
              <CustomInputProduct
                value={old}
                onChange={(v) => setold(v)}
                title="อายุ"
                placeHolder="กรุณาใส่รายละเอียด"
                fontSize={14}
              />
              <CustomInputProduct
                value={technic}
                onChange={(v) => settechnic(v)}
                title="เทคนิคการทอ"
                placeHolder="กรุณาใส่รายละเอียด"
                fontSize={14}
              />

              <CustomInputProduct
                value={pattern}
                onChange={(v) => setpattern(v)}
                title="ลาย"
                placeHolder="กรุณาใส่รายละเอียด"
                fontSize={14}
              />
              <CustomInputProduct
                value={material}
                onChange={(v) => setmaterial(v)}
                title="วัสดุ"
                placeHolder="กรุณาใส่รายละเอียด"
                fontSize={14}
              />
              <div className="grid grid-cols-3 gap-2 col-span-2">
                <CustomInputProduct
                  value={width}
                  onChange={(v) => setwidth(v)}
                  title="กว้าง"
                  placeHolder="กรุณาใส่รายละเอียด"
                  fontSize={14}
                />
                <CustomInputProduct
                  value={length}
                  onChange={(v) => setlength(v)}
                  title="ยาว"
                  placeHolder="กรุณาใส่รายละเอียด"
                  fontSize={14}
                />
                <CustomInputProduct
                  value={depth}
                  onChange={(v) => setdepth(v)}
                  title="ลึก"
                  placeHolder="กรุณาใส่รายละเอียด"
                  fontSize={14}
                />
              </div>
              <CustomInputProduct
                value={attribute_old}
                onChange={(v) => setattribute_old(v)}
                title="คุณลักษณะ (เดิม)"
                placeHolder="กรุณาใส่รายละเอียด"
                fontSize={14}
              />
              <CustomInputProduct
                value={note}
                onChange={(v) => setnote(v)}
                title="หมายเหตุ"
                placeHolder="กรุณาใส่รายละเอียด"
                fontSize={14}
              />
            </div>
          </div>
          <div className=" flex flex-row gap-3 my-6 justify-center items-center">
            <CustomButton
              txt={"Save"}
              bgcolor="#2271B1"
              onClick={() => {
                saveData();
              }}
            />
            <CustomButton
              txt={"Cancel"}
              bgcolor="#9E0400"
              onClick={() => {
                router(-1);
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
